import React, { useRef, useState } from 'react'
import { Suspense } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, Preload, useGLTF } from '@react-three/drei'
import CanavasLoader from '../components/Loader'
const ThreeD = (props) => {
    const model = useGLTF('./astronaut_balloon_pubg/scene.gltf');
    const groupRef = useRef();

    // This state will hold the rotation values
    const [rotation, setRotation] = useState({ x: 0, y: 0, z: 0 });

    // This function will update the rotation based on user input
    const handleRotation = () => {
        setRotation({
            x: rotation.x + 0.005, // Adjust the rotation speed as needed
            y: rotation.y + 0.005,
            z: rotation.z + 0.005,
        });
    };

    // Attach an event listener to call handleRotation on each frame
    useFrame(() => handleRotation());

    return (
        <group ref={groupRef} rotation={[rotation.x, rotation.y, rotation.z]}>
            <hemisphereLight intensity={2.3} groundColor="black" />
            <pointLight intensity={3} />
            <spotLight
                position={[0, 10, 5]}
                angle={0.5}
                penumbra={1}
                intensity={50}
                castShadow
                shadow-mapSize={1024}
            />
            <primitive
                object={model.scene}
                scale={props.isMobile ? [1, 1, 1] : [5, 5, 5]}
                position={props.isMobile ? [0, -3, -2.2] : [0, -2, -1.5]}
            />
        </group>
    );
};

const ModelCanavas = () => {
    return (
        <Canvas
            shadows
            frameloop='demand'
            gl={{ preserveDrawingBuffer: true }}
            camera={{
                fov: 45,
                near: 0.1,
                far: 200,
                position: [-4, 3, 6],
            }}
        >
            <Suspense fallback={<CanavasLoader />}>
                <OrbitControls
                    autoRotate
                    enableZoom={false}
                    maxPolarAngle={Math.PI / 2}
                    minPolarAngle={Math.PI / 2}
                />
                <ThreeD />
            </Suspense>
        </Canvas>
    )
}

export default ModelCanavas

